// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"66":"98f6355ffc76457b","137":"ae050027c8a511e2","630":"a111db4847bb3d05","912":"136c51c4d87b6b0c","937":"2760309b82ae1568"}[chunkId] + ".js";
};